import React, { useState } from "react";
import image from "../assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <div className="bg-[#FCFCFF]">
      <div className="md:hidden block">
        <div className="flex justify-between items-center px-4 py-4">
          <div>
            <img src={image} alt="Applitics" />
          </div>
          <div>
            {isOpen ? (
              <button onClick={handleClose}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="30"
                  height="30"
                >
                  <path
                    d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                    fill="rgba(0,0,0,1)"
                  ></path>
                </svg>
              </button>
            ) : (
              <button onClick={handleToggle}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="22"
                  height="22"
                >
                  <path
                    d="M12 3V5H3V3H12ZM16 19V21H3V19H16ZM22 11V13H3V11H22Z"
                    fill="rgba(0,0,0,1)"
                  ></path>
                </svg>
              </button>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="absolute bg-white z-10 left-0 right-0 p-4 border-t border-b">
            <div>
              <ul className="text-primary">
                <li className="px-2 py-2 cursor-pointer font-extrabold text-[#5271FF]">
                  Home
                </li>
                <li className="px-2 py-2 cursor-pointer">About Us</li>
                <li className="px-2 py-2 cursor-pointer">Features</li>
                <li className="px-2 py-2 cursor-pointer">Benefits</li>
                <li className="px-2 py-2 cursor-pointer pb-6">Contact Us</li>
              </ul>
            </div>
            <div className="text-primary font-bold gap-3">
              <div className="block w-full text-primary text-center px-6 py-3 rounded-[6px] bg-[#F0F0F0] cursor-pointer">
                Sign In
              </div>
              <div className="block w-full bg-[#FF5271] text-center mt-4 py-3 text-white rounded-[6px] px-6 cursor-pointer">
                Sign Up
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="md:block hidden max-w-[1240px] px-4 container py-10">
        <div className="flex justify-between items-center">
          <div>
            <img src={image} alt="Applitics" />
          </div>
          <div>
            <ul className="flex item-center gap-10 text-primary">
              <li className="cursor-pointer font-extrabold text-[#5271FF]">Home</li>
              <li className="cursor-pointer">About Us</li>
              <li className="cursor-pointer">Features</li>
              <li className="cursor-pointer">Benefits</li>
              <li className="cursor-pointer">Contact Us</li>
            </ul>
          </div>
          <div className="flex items-center text-primary font-bold gap-3">
            <div className="text-primary px-6 py-3 rounded-[6px] bg-[#F0F0F0] cursor-pointer">
              Sign In
            </div>
            <div className="bg-[#FF5271] py-3 text-white rounded-[6px] px-6 cursor-pointer">
              Sign Up
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
